// SENVÈ Labor Day campaign — single global countdown engine.
//
// One setInterval ticks once per second and updates every
// [data-senve-countdown] element on the page from the SAME deadline
// (window.SenveCampaign.deadlineEpoch, rendered once in theme.liquid via
// snippets/senve-campaign-config.liquid, sourced from the "Labor Day
// Campaign" settings group). No component keeps its own interval or its
// own copy of the deadline, so nothing can drift out of sync with
// anything else.
//
// When the deadline passes: numeric countdown elements hide themselves
// (no negative values), a `senve:campaign-expired` event fires once so
// other scripts (e.g. the popup) can react without a page reload, and the
// interval clears itself.
(() => {
  if (window.__senveCampaignEngineStarted) return;
  window.__senveCampaignEngineStarted = true;

  const campaign = window.SenveCampaign || {};
  if (!campaign.enabled || !campaign.deadlineEpoch) return;

  const deadlineMs = campaign.deadlineEpoch * 1000;

  function computeRemaining() {
    return deadlineMs - Date.now();
  }

  function render(remainingMs) {
    const totalSeconds = Math.max(0, Math.floor(remainingMs / 1000));
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    const pad = (n) => String(n).padStart(2, '0');

    document.querySelectorAll('[data-senve-countdown]').forEach((el) => {
      const d = el.querySelector('[data-unit="d"]');
      const h = el.querySelector('[data-unit="h"]');
      const m = el.querySelector('[data-unit="m"]');
      const s = el.querySelector('[data-unit="s"]');
      if (d) d.textContent = pad(days);
      if (h) h.textContent = pad(hours);
      if (m) m.textContent = pad(minutes);
      if (s) s.textContent = pad(seconds);
    });
  }

  function expire() {
    document.querySelectorAll('[data-senve-countdown]').forEach((el) => {
      el.hidden = true;
      el.style.display = 'none';
    });
    document.body.classList.add('senve-campaign-expired');
    document.dispatchEvent(new CustomEvent('senve:campaign-expired'));
  }

  let intervalId = null;

  function tick() {
    const remaining = computeRemaining();
    if (remaining <= 0) {
      if (intervalId) clearInterval(intervalId);
      expire();
      return;
    }
    render(remaining);
  }

  tick();
  if (computeRemaining() > 0) {
    intervalId = setInterval(tick, 1000);
  }
})();
